export default __webpack_public_path__ + "static/media/EducationalResources_Thumbnail.7d03339b.png";